import {Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class HttpI18nInterceptor implements HttpInterceptor {

    constructor(private translate: TranslateService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.indexOf("/assets/i18n/") > 0) {
            return next.handle(request.clone({ withCredentials: false }));
        }

        const lang = this.translate.currentLang || this.translate.defaultLang || 'it';

        if (request.url.indexOf("/api/maps/") > -1) {
            return next.handle(request.clone({
                withCredentials: false,
                setHeaders: { 'Accept-Language': lang }
            }));
        }

        return next.handle(request.clone({
            setHeaders: { 'Accept-Language': lang }
        }));
    }

}
